import Http from '@/api/http.js'

export default {
  updateInfos(driver){
    return Http.put(`/drivers/${driver.id}`, {
      driver: {...driver},
    });
  },
  show(id, filter = {}) {
    return Http.get(`/drivers/${id}`, {params: {...filter}})
  },

  delete(){
    // return Http.delete(`/action_plans/${id}`)
  },

  updateWithFormData(driver){
    return Http.put(`/drivers/${driver.get('driver[id]')}`, driver);
  },

  checkDriverCpf(cpf){
    return Http.get(`/drivers/check_document`, {
      params: {
        cpf,
      }
    });
  },
  checkDriverCnpj(cnpj){
    return Http.get(`/drivers/check_document`, {
      params: {
        cnpj,
      }
    });
  },

  exportCsv(filter){
    return Http.get(`/drivers.csv`, {params:{ filter: filter}});
  },
  exportPdf(filter){
    return Http.get(`/drivers.pdf`, {params:{ filter: filter}});
  },
  exportXlsx(filter){
    return Http.get(`/drivers.xlsx`, {params:{ filter: filter}});
  },
  indexDeliveries(filter) {
    return Http.get('/deliveries', {params: filter})
  },
  showDelivery(id) {
    return Http.get('/deliveries/'+id)
  },
  index(filter) {
    return Http.get('/drivers',{params: {...filter}})
  },

  create(driver){
    const {accounts, address, contatos, ...rest} = driver
    return Http.post(`/drivers`, {
      driver: {
        ...rest,
      }
    })
  },
  
  update(updateDriver, id) {
    return Http.put(`/drivers/${id}`, {
      driver: {
        name:         updateDriver.name,
        cnh:          updateDriver.cnh,
        cpf:          updateDriver.cpf.toString().replace(/[\W]/g, ""),
        external:     true,
        documents:    updateDriver.documents,
        truck_id:     updateDriver.truck_id,
        status_id:    updateDriver.status_id,
        driver_id:  null,
        'driver_attributes':      updateDriver.driver_attributes,
        'contacts_attributes': updateDriver.contacts_attributes,
        'address_attributes': updateDriver.address_attributes,
        'accounts_attributes': updateDriver.accounts_attributes,

        'vrt_account_attributes': updateDriver.vrt_account_attributes,

        role_id: 2,

        // 'document_attributes':   updateDriver.attachment_attributes,

      }
    })
  },
  updateInfo(updateDriver, id) {
    return Http.put(`/drivers/${id}`, {
      driver: {
        id: id,
        name: updateDriver.driver_attributes.name,
        cnh: updateDriver.driver_attributes.cnh,
        cpf: updateDriver.driver_attributes.cpf.toString().replace(/[\W]/g, ""),

        status_id:    updateDriver.driver_attributes.status_id,

        'document_attributes':   updateDriver.driver_attributes.document_attributes,

      }
    });
  },
  updateContact(updateDriver, id) {
    return Http.put(`/drivers/${id}`, {
      driver: {
        id: id,
        'contacts_attributes':  updateDriver.contacts_attributes,
      }
    });
  },
  updateAccount(updateDriver, id) {
    return Http.put(`/drivers/${id}`, {
      driver: {
        id: id,
        'accounts_attributes':  updateDriver.update_accounts_attributes,
        receipt_config: updateDriver.receipt_config,
        freight_kind_default: updateDriver.freight_kind_default,
      }
    });
  },
  updateAddress(updateDriver, id) {
    return Http.put(`/drivers/${id}`, {
      driver: {
        id: id,
        'address_attributes':   updateDriver.address_attributes,
      }
    });
  },
  show(id, filter = {}) {
    return Http.get(`/drivers/${id}`, {params: {...filter}})
  },
 
  getOpenPaymentsPdf(id, params){
    return Http.get("/drivers/"+id+"/payment_pdf", { responseType: 'blob', params })
  },

  getHistoryPaymentsPdf(filter){
    return Http.get("/drivers/"+filter.id+"/payment_pdf", { 
      params: { ...filter, history: true },
      responseType: 'blob'
    })
  },

  

}
